import { createAction } from "@reduxjs/toolkit";
import { AcknowledgeMessagePayload, AddMessagePayload } from "./messages-types";

export const AddMessageAction = createAction<AddMessagePayload>("ADD_MESSAGE");
export const AcknowledgeMessageAction = createAction<AcknowledgeMessagePayload>("ACKNOWLEDGE_MESSAGE");
